const BLACKLISTED_PATHS = [
    '/shop/cart/',
    '/app/shop/cart/',

    '/shop/checkout/',
    '/shop/checkout/login/',
    '/shop/checkout/address/',
    '/secure/checkout/payment/',
    '/shop/checkout/confirmation/',

    '/app/shop/checkout/',
    '/app/shop/checkout/login/',
    '/app/shop/checkout/address/',
    '/app/secure/checkout/payment/',
    '/app/shop/checkout/confirmation/',
    '/app/shop/checkout/success/',
];

const isBlackListedPath = (checkPath: string): boolean => BLACKLISTED_PATHS.includes(checkPath);

export { isBlackListedPath };
